<template>
  <div class="connector-detail" v-if="connector">
    <b-card class="mb-3">
      <b-row align-v="center">
        <b-col>
          <h4 class="mb-0">
            {{ connector.name }}
            <b-badge :variant="connector.is_active ? 'success' : 'secondary'" class="ml-2">
              {{ connector.is_active ? 'Active' : 'Inactive' }}
            </b-badge>
          </h4>
          <small class="text-muted">{{ connector.description }}</small>
        </b-col>
        <b-col cols="auto">
          <b-button
            :variant="connector.is_active ? 'outline-warning' : 'outline-success'"
            size="sm"
            @click="toggleStatus"
          >
            {{ connector.is_active ? 'Deactivate' : 'Activate' }}
          </b-button>
          <b-button
            variant="outline-secondary"
            size="sm"
            class="ml-1"
            @click="$router.push({ name: 'appConnectors' })"
          >
            <i class="fa fa-arrow-left mr-1" />
            Back
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-tabs content-class="mt-3" v-model="activeTab">
      <b-tab title="Overview">
        <OverviewTab :connector-id="connectorId" />
      </b-tab>
      <b-tab title="Scopes">
        <ScopesTab :connector-id="connectorId" />
      </b-tab>
      <b-tab title="Mappings">
        <MappingsTab :connector-id="connectorId" />
      </b-tab>
      <b-tab title="Webhooks">
        <WebhooksTab :connector-id="connectorId" />
      </b-tab>
      <b-tab title="Logs">
        <LogsTab :connector-id="connectorId" />
      </b-tab>
      <b-tab title="Settings">
        <SettingsTab :connector-id="connectorId" @deleted="$router.push({ name: 'appConnectors' })" />
      </b-tab>
    </b-tabs>
  </div>
  <div v-else class="text-center py-5">
    <b-spinner variant="primary" />
  </div>
</template>

<script>
import OverviewTab from './tabs/OverviewTab.vue'
import ScopesTab from './tabs/ScopesTab.vue'
import MappingsTab from './tabs/MappingsTab.vue'
import WebhooksTab from './tabs/WebhooksTab.vue'
import LogsTab from './tabs/LogsTab.vue'
import SettingsTab from './tabs/SettingsTab.vue'

export default {
  components: { OverviewTab, ScopesTab, MappingsTab, WebhooksTab, LogsTab, SettingsTab },
  props: {
    id: { type: [String, Number], required: true },
  },
  data() {
    return {
      activeTab: 0,
    }
  },
  computed: {
    connectorId() {
      return Number(this.id)
    },
    connector() {
      return this.$store.state.appConnector.item
    },
  },
  async mounted() {
    await this.$store.dispatch('appConnector/fetchById', this.connectorId)
  },
  methods: {
    async toggleStatus() {
      await this.$store.dispatch('appConnector/toggleStatus', this.connectorId)
    },
  },
}
</script>
